module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acces-word",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('button', [_c('div', {
    staticClass: "acces-icon back-red hvr-grow"
  }, [_c('v-icon', {
    staticClass: "always-white"
  }, [_vm._v("fa fa-sign-language")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "accef-gif back-red animated fadeIn",
    class: _vm.pos
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgUrl(_vm.gifSrc),
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb530d4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/HoverGif.vue
// module id = 1048
// module chunks = 1